<div>
  <a (click)="logout()"  href="#" data-toggle="dropdown" title="Logout"
     class="header-icon d-flex align-items-center justify-content-center ml-2">
    <i class="fal  fa-sign-out-alt"></i>
  </a>
</div>
